var _linearGradient, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 174,
    viewBox: "0 0 272 174",
    width: 272,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 7645.42,
    x2: 7645.42,
    y1: 6038.72,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h272v174h-272z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f2f2f2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m258.196 28.365h-41.543c-1.263 0-2.286 1.0223-2.286 2.2833v.4058c0 1.261 1.023 2.2833 2.286 2.2833h41.543c1.263 0 2.286-1.0223 2.286-2.2833v-.4058c0-1.261-1.023-2.2833-2.286-2.2833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.527 32.6016h-41.542c-1.263 0-2.287 1.0222-2.287 2.2833v.4058c0 1.261 1.024 2.2833 2.287 2.2833h41.542c1.263 0 2.287-1.0223 2.287-2.2833v-.4058c0-1.2611-1.024-2.2833-2.287-2.2833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.003 36.2854h-41.543c-1.263 0-2.287 1.0223-2.287 2.2833v.4058c0 1.261 1.024 2.2833 2.287 2.2833h41.543c1.262 0 2.286-1.0223 2.286-2.2833v-.4058c0-1.261-1.024-2.2833-2.286-2.2833z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m239.087 37.2071c10.29 0 18.631-8.3291 18.631-18.6035 0-10.2745-8.341-18.6036-18.631-18.6036s-18.632 8.3291-18.632 18.6036c0 10.2744 8.342 18.6035 18.632 18.6035z",
    fill: "url(#a)",
    opacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m239.087 35.1806c9.169 0 16.602-7.4218 16.602-16.577 0-9.15522-7.433-16.57699-16.602-16.57699s-16.602 7.42177-16.602 16.57699c0 9.1552 7.433 16.577 16.602 16.577z",
    fill: "#fccc63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m121.901 56.2783c-.271 1.4855-1.187 4.6217-4.147 4.5437-2.259-.0573-3.999-2.0265-3.939-4.2823l.851-30.7194.278-10.0182s1.465-2.7716 2.923 9.6537v.0458l4.05 29.4631c.065.4359.059.8794-.016 1.3136z",
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m119.929 59.261h-4.349v9.2869h4.349z",
    fill: "#f2f2f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m119.46 66.3423h-3.345v4.0761h3.345z",
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m117.874 25.5041c-1.522-.4425-2.558-.1055-3.215.3186l.278-10.0182s1.465-2.7716 2.923 9.6537z",
    fill: "#667eea"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m119.929 62.037v6.5107h-4.349v-6.3823c1.38-.5966 2.936-.6425 4.349-.1284z",
    fill: "#667eea"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m130.166 82.7361c-1.219-.8941-3.639-3.0903-2.273-5.7129 1.042-2.0014 3.577-2.7029 5.581-1.6598l27.278 14.2318 8.897 4.64s1.85 2.5217-9.973-1.6047l-.044-.0138-28.297-9.2846c-.419-.1363-.813-.3374-1.169-.596z",
    fill: "#f2f2f2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m121.895 71.6875-1.906 3.9026 8.359 4.0711 1.907-3.9026z",
    fill: "#f2f2f2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m122.179 76.1367 1.466-3.0022-3.669-1.7868-1.466 3.0021z",
    fill: "#f2f2f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m159.632 92.6144c1.065-1.1737 1.217-2.2512 1.12-3.0192l8.897 4.64s1.85 2.5218-9.973-1.6047z",
    fill: "#667eea"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m125.85 78.4421-5.862-2.8542 1.906-3.8972 5.74 2.7968c-.067 1.4973-.706 2.9123-1.784 3.9546z",
    fill: "#667eea"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m105.343 82.7361c1.219-.8941 3.639-3.0903 2.273-5.7129-1.043-2.0014-3.577-2.7029-5.582-1.6598l-27.2776 14.2318-8.8967 4.64s-1.8505 2.5217 9.9735-1.6047l.0436-.0138 28.2972-9.2823c.419-.137.813-.3389 1.169-.5983z",
    fill: "#f2f2f2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m113.614 71.687-8.36 4.0711 1.906 3.9025 8.36-4.0711z",
    fill: "#f2f2f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m116.998 74.3486-1.466-3.0022-3.669 1.7869 1.466 3.0021z",
    fill: "#f2f2f2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m75.8768 92.6144c-1.0653-1.1737-1.2168-2.2512-1.1204-3.0192l-8.8967 4.64s-1.8505 2.5218 9.9735-1.6047z",
    fill: "#667eea"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m109.659 78.4421 5.861-2.8542-1.905-3.8972-5.74 2.7968c.067 1.4973.705 2.9123 1.784 3.9546z",
    fill: "#667eea"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m121.667 173.626h-8.53l2.709-100.303h3.111z",
    fill: "#f2f2f2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m117.754 74.9255c1.57 0 2.843-1.2707 2.843-2.8381 0-1.5675-1.273-2.8381-2.843-2.8381-1.569 0-2.842 1.2706-2.842 2.8381 0 1.5674 1.273 2.8381 2.842 2.8381z",
    fill: "#667eea"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m185.057 50.992c-.181 1.0041-.801 3.1246-2.803 3.0719-.738-.0339-1.431-.3572-1.931-.8995-.5-.5422-.765-1.2596-.737-1.9959l.578-20.7837.186-6.7766s.992-1.8753 1.979 6.5313v.0298l2.739 19.9446c.043.2915.039.5878-.011.8781z",
    fill: "#f2f2f2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m183.723 53.0071h-2.941v6.2837h2.941z",
    fill: "#f2f2f2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m183.406 57.7983h-2.264v2.7579h2.264z",
    fill: "#f2f2f2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m182.334 30.1715c-1.031-.2981-1.731-.0711-2.17.2155l.186-6.7766s.992-1.8753 1.979 6.5313z",
    fill: "#667eea"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m183.723 54.8845v4.4016h-2.941v-4.3122c.933-.4048 1.985-.4369 2.941-.0894z",
    fill: "#667eea"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m190.643 68.8894c-.824-.6029-2.464-2.0885-1.538-3.8629.353-.6471.949-1.1283 1.656-1.3388.708-.2104 1.47-.1329 2.12.2155l18.455 9.6285 6.018 3.1384s1.253 1.7125-6.746-1.0866h-.03l-19.145-6.2792c-.284-.0957-.551-.2358-.79-.4149z",
    fill: "#f2f2f2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m185.053 61.4159-1.29 2.6395 5.657 2.7546 1.289-2.6394z",
    fill: "#f2f2f2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m185.247 64.4271.992-2.0316-2.482-1.209-.992 2.0317z",
    fill: "#f2f2f2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m210.585 75.5743c.721-.7932.824-1.5222.758-2.0426l6.017 3.1384s1.254 1.7125-6.745-1.0866z",
    fill: "#667eea"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m187.729 65.987-3.974-1.9326 1.288-2.6386 3.887 1.8913c-.043 1.0135-.473 1.9722-1.201 2.6799z",
    fill: "#667eea"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m173.855 68.8894c.824-.6029 2.464-2.0885 1.538-3.8629-.353-.6471-.949-1.1283-1.656-1.3388-.708-.2104-1.47-.1329-2.12.2155l-18.455 9.6285-6.018 3.1384s-1.253 1.7125 6.746-1.0866h.03l19.145-6.2792c.284-.0957.551-.2358.79-.4149z",
    fill: "#f2f2f2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m179.453 61.417-5.656 2.7546 1.289 2.6395 5.657-2.7546z",
    fill: "#f2f2f2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m181.741 63.2167-.992-2.0316-2.483 1.2089.993 2.0317z",
    fill: "#f2f2f2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m153.92 75.5743c-.721-.7932-.825-1.5222-.758-2.0426l-6.018 3.1384s-1.253 1.7125 6.746-1.0866z",
    fill: "#667eea"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m176.775 65.987 3.966-1.9326-1.288-2.6386-3.887 1.8913c.045 1.0148.478 1.9736 1.209 2.6799z",
    fill: "#667eea"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m184.901 130.383-5.8 1.018 1.86-68.8778h2.105z",
    fill: "#f2f2f2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m182.254 63.6073c1.062 0 1.924-.8601 1.924-1.9211s-.862-1.9211-1.924-1.9211c-1.063 0-1.924.8601-1.924 1.9211s.861 1.9211 1.924 1.9211z",
    fill: "#667eea"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m53.4641 50.992c-.1814 1.0041-.8013 3.1246-2.8034 3.0719-.7369-.0339-1.4306-.3573-1.9299-.8996-.4992-.5423-.7637-1.2597-.7356-1.9958l.5763-20.7837.1859-6.7766s.9919-1.8753 1.9791 6.5313v.0298l2.7413 19.9446c.0404.2917.0358.5878-.0137.8781z",
    fill: "#f2f2f2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m52.1301 53.0071h-2.9411v6.2837h2.9411z",
    fill: "#f2f2f2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m51.8133 57.7983h-2.2638v2.7579h2.2638z",
    fill: "#f2f2f2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m50.7411 30.1715c-1.0286-.2981-1.7311-.0711-2.1696.2155l.1859-6.7766s.9919-1.8753 1.9791 6.5313z",
    fill: "#667eea"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m52.1301 54.8845v4.4016h-2.9411v-4.3122c.9327-.4048 1.9855-.4369 2.9411-.0894z",
    fill: "#667eea"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m59.0569 68.8892c-.8243-.6029-2.4612-2.0884-1.536-3.8628.3531-.647.9482-1.1282 1.6553-1.3386.7072-.2105 1.469-.1331 2.1192.2153l18.4546 9.6284 6.0199 3.1384s1.2513 1.7125-6.7477-1.0866h-.0298l-19.1434-6.2791c-.2843-.0958-.5517-.2358-.7921-.415z",
    fill: "#f2f2f2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m53.4606 61.4167-1.2893 2.6395 5.6562 2.7546 1.2893-2.6395z",
    fill: "#f2f2f2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m53.6535 64.4267.9924-2.0317-2.4825-1.209-.9924 2.0317z",
    fill: "#f2f2f2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m78.9924 75.5743c.7209-.7932.8242-1.5222.7576-2.0426l6.0199 3.1384s1.2513 1.7125-6.7477-1.0866z",
    fill: "#667eea"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m56.1365 65.987-3.9651-1.9326 1.2904-2.6386 3.8846 1.8913c-.0448 1.015-.4779 1.9742-1.2099 2.6799z",
    fill: "#667eea"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m42.2623 68.8894c.8265-.6029 2.4635-2.0885 1.5382-3.8629-.3535-.6471-.949-1.1283-1.6565-1.3388-.7076-.2104-1.4697-.1329-2.1203.2155l-18.4545 9.6285-6.0176 3.1384s-1.2536 1.7125 6.7454-1.0866h.0298l19.1457-6.2792c.2835-.0957.5501-.2358.7898-.4149z",
    fill: "#f2f2f2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m47.86 61.4163-5.6562 2.7546 1.2893 2.6395 5.6562-2.7546z",
    fill: "#f2f2f2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m50.15 63.2182-.9923-2.0317-2.4825 1.209.9924 2.0316z",
    fill: "#f2f2f2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m22.3268 75.5743c-.7186-.7932-.8219-1.5222-.7577-2.0426l-6.0175 3.1384s-1.2536 1.7125 6.7454-1.0866z",
    fill: "#667eea"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m45.1827 65.987 3.965-1.9326-1.288-2.6386-3.887 1.8913c.047 1.0145.4797 1.973 1.21 2.6799z",
    fill: "#667eea"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m53.3079 130.383h-5.772l1.8345-67.8598h2.103z",
    fill: "#f2f2f2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m50.6607 63.6073c1.0626 0 1.924-.8601 1.924-1.9211s-.8614-1.9211-1.924-1.9211-1.9239.8601-1.9239 1.9211.8613 1.9211 1.9239 1.9211z",
    fill: "#667eea"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m245.215 148.922c-1.965 7.157-6.23 13.472-12.139 17.973s-13.135 6.939-20.567 6.94h-172.8985c-7.991-.005-15.8243-2.221-22.63-6.403-6.8057-4.181-12.31741-10.165-15.9231-17.285 0 0 25.06-34.612 90.1423-11.999 54.0323 18.773 78.9543 1.02 85.8673-5.55.748-.709 1.633-1.258 2.599-1.616.967-.358 1.996-.516 3.026-.466 13.241.626 59.106 3.831 62.529 18.402z",
    fill: "#f2f2f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergies);
export default __webpack_public_path__ + "static/media/energies.baed0172c064ec3244c3e00a7317bad1.svg";
export { ForwardRef as ReactComponent };